export default __webpack_public_path__ + "static/media/KHacksVID.8da0218c.mp4";